import React from 'react';
import { CheckIcon } from 'lucide-react';
import { OFFER_ANCHOR, boxImage, systemChecks } from '../data/salesCopy';
export function SystemIntro() {
  return <section className="bg-brand-brown px-4 py-9 sm:py-12" data-id="element-177" data-mp="1yg2ibr8ov75z">
      <div className="mx-auto max-w-3xl text-center" data-id="element-178" data-mp="23a6nc4ye954f">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-179" data-mp="287yo7oh0o1kr">
          Le système visuel complet 6-en-1
        </p>
        <h2 className="mt-1.5 font-serif text-3xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-180" data-mp="1bj0um9l069p6">
          🧘 Yin Yoga Pro™
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-[12.5px] font-semibold uppercase leading-snug tracking-wide text-brand-sand sm:text-sm" data-id="element-181" data-mp="1kidty9fexhw6">
          Des ressources visuelles prêtes à utiliser pour les professeurs de Yin
          Yoga
        </p>
        <p className="mt-1.5 text-[12px] font-medium text-white/70 sm:text-[13px]" data-id="element-182" data-mp="2vwhp3ixqlc2t">
          Postures • Séquences • Création • Adaptations • Thématiques •
          Planification
        </p>

        <a href={OFFER_ANCHOR} className="mt-4 block" data-id="element-183" data-mp="15hm495i84qoe">
          <img src={boxImage} alt="Les 6 modules du système YIN YOGA PRO™" className="mx-auto w-full max-w-[280px] sm:max-w-[340px]" data-id="element-184" data-mp="15gay4z1b36u4" />
        </a>

        <ul className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-1.5 text-left sm:grid-cols-2" data-id="element-185" data-mp="wjs9hz03y53c">
          {systemChecks.map(item => <li key={item} className="flex items-start gap-1.5 rounded bg-white/10 px-2.5 py-1.5 text-[12.5px] font-semibold leading-snug text-white" data-id="element-186" data-mp="mk1d1rrzlg0m">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-187" data-mp="dqy1xq4tdf95" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}